import React from 'react'

import Decimal from './decimal'

const Percentage = ({ value }) => <Decimal value={value} suffix=" %" />

export default Percentage
